export default "__VITE_ASSET__c1f6091a__"